import { oc } from '@orpc/contract';
import { healthOutputSchema } from '../schemas/health.schemas.js';
export const getHealthContract = oc
    .route({
    method: 'GET',
    path: '/health',
    tags: ['Health'],
    summary: 'Liveness probe including what the database reports about itself',
})
    .output(healthOutputSchema);
//# sourceMappingURL=get-health.contract.js.map